import { i18n } from '@lingui/core';
import '@warp-ds/icons/elements/search-24';
import React from 'react';

type SearchboxButtonProps = {
    className?: string;
};

export function SearchboxButton(props: SearchboxButtonProps) {
    const { className = '' } = props;

    return (
        <button
            aria-label={i18n.t({
                id: 'searchbox.button.submit',
                message: 'Search',
            })}
            className={`${className} suffix suffix--icon`}
            type="submit"
        >
            {/* @ts-expect-error Property 'w-icon-search-24' does not exist on type 'JSX.IntrinsicElements'.ts(2339) */}
            <w-icon-search-24 class="flex"></w-icon-search-24>
        </button>
    );
}
